@if(service.viewDroplistItems.length){
<div class="volunteering-specialists-views-part">

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='uniqueId' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.SignUps) {
	<sign-ups-view-part></sign-ups-view-part>
	}
	@case (service.viewId.SessionAssignments) {
	<session-assignments-view-part></session-assignments-view-part>
	}
	@case (service.viewId.SpecialistPool) {
	<specialist-pool-view-part></specialist-pool-view-part>
	}
	@case (service.viewId.ApprovedSpecialistsByTopic) {
	<approved-specialists-by-topic-view-part></approved-specialists-by-topic-view-part>
	}
	@case (service.viewId.NotApprovedSpecialistsByTopic) {
	<not-approved-specialists-by-topic-view-part></not-approved-specialists-by-topic-view-part>
	}
	}
	}

</div>
}